// extracted by mini-css-extract-plugin
export var closed = "FAQ-module--closed--2e4e0";
export var fadeSlideDown = "FAQ-module--fade-slide-down--68218";
export var fadeSlideUp = "FAQ-module--fade-slide-up--94025";
export var faq = "FAQ-module--faq--7486b";
export var open = "FAQ-module--open--117a4";
export var text = "FAQ-module--text--69535";
export var textContainer = "FAQ-module--textContainer--c43b3";